import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import { action } from 'Shared/Routes';
import { pack_status } from 'Shared/options';
export default class PackOrderIndexRow extends Component {
  state = {
    loading: false
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row '
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-date"
    }, data.code), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-hours"
    }, moment(data.created_at).format("DD/MM/YYYY")), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-amount"
    }, data.expiration_date ? moment(data.expiration_date).format('DD/MM/YYYY') : 'Pack en attente'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, data.remaining_credit), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, /*#__PURE__*/React.createElement("a", {
      href: action('getPackOrderIndexPDF').replace(':packorder_id', data.packorder_id),
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer",
      className: "c-dashboard__pdf-link"
    }, /*#__PURE__*/React.createElement(PDFIcon, {
      className: "c-dashboard__pdf-icon"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-number_of_people"
    }, pack_status.find(opt => opt.value === data.status)?.label));
    return output;
  }
}
